// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const DepartmentModel = ({ }) => {

    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);
    const [IsReloadDepartmentClicked, setIsReloadDepartmentClicked] = useState(false);

    const handleReloadDepartmentClick = async () => {
        setIsReloadDepartmentClicked(true);

        try {
            setLoading(true);

        let currentPage = 0;
        let allDepartments = [];
        let totalPages = 1;

        do {
            const response = await DepartmentsApi.ListDepartments(currentPage, 10);

            allDepartments = [
                ...allDepartments,
                ...(response?.payloadDto || [])
            ];

            totalPages = response?.totalPages || 0;
            currentPage++;

        } while (currentPage < totalPages);

        setDepartments(allDepartments);
        setTotalPageNew(totalPages);
        setPage(currentPage);

    } catch (error) {
        console.error("Error fetching departments:", error);
    } finally {
        setLoading(false);

        setTimeout(() => {
            setIsReloadDepartmentClicked(false);
        }, 1000);
    }
};

    const fetchAllDepartments = async () => {
        try {
            setLoading(true);

            let currentPage = 0;
            let allDepartments = [];
            let totalPages = 1;
            do {

            const response = await DepartmentsApi.ListDepartments(currentPage, 10);
                const departments = response?.payloadDto || [];
                allDepartments = [...allDepartments, ...departments];
                totalPages = response?.totalPages || 0;
                currentPage++;
                
            } while (currentPage < totalPages);
            setDepartments(allDepartments);
            setTotalPageNew(totalPages);
            setPage(currentPage);
        } catch (error) {
            console.error("Error fetching departments:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchAllDepartments();
    }, []);

    return (
        <><div className="row product-row d-flex ">
            <Form.Item
                name="institutionId"
                label="Department :"
                className="text-lable col-10"
                rules={[
                    {
                        required: true,
                        message: "Please Select Department.",
                    },
                ]}
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Department"
                >
                    {departments.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.institutionName}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-2">
                {IsReloadDepartmentClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadDepartmentClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row pb-2 ">
                <div className="col-4"></div>
                <div className="col-6">
                    <Link
                        to={"/masters/departments/add-department"}
                        target="_blank"
                    >
                        <u>Create New Department</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default DepartmentModel;
